import { render, staticRenderFns } from "./TaskManagement.vue?vue&type=template&id=4470f6f2&scoped=true"
import script from "./TaskManagement.vue?vue&type=script&lang=ts"
export * from "./TaskManagement.vue?vue&type=script&lang=ts"
import style0 from "./TaskManagement.vue?vue&type=style&index=0&id=4470f6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4470f6f2",
  null
  
)

export default component.exports